import {getGroupProduct, getSalaryDeductionOccupationClassInfo} from 'ApplicationEntry/api/awdApi';
import ApplicationEntryRouteConstants from 'ApplicationEntry/ApplicationEntryRouteConstants';
import * as S from 'ApplicationEntry/ducks/ProductsRiders/shop';
import {push} from 'connected-react-router';
import {AsyncResult, Loaded} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {all, call, put, takeLatest} from 'redux-saga/effects';
import {
  SalaryDeductionOccupationClassInfo,
  SalaryDeductionOccupationClassInfoWarning,
} from 'ApplicationEntry/models/ProductsRiders/SalaryDeductionOccupationClassModel';

function* getPackageList() {
  yield takeLatest(S.ShopActionType.GET_PACKAGE_LIST, function*(action: ReturnType<typeof S.getPackages>) {
    const {payload} = action;
    const {caseNumber, planCode} = payload;

    const response: AsyncResult<{packages: object[]}> = yield call(getGroupProduct, caseNumber, planCode);
    if (E.isRight(response)) {
      yield put(S.changePackageList(new Loaded(response.right.packages)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      yield put(S.changePackageList(response.left));
    }
  });
}
function* getSalaryDeductionOccupationClass() {
  yield takeLatest(S.ShopActionType.GET_OCC_CLASS, function*(action: ReturnType<typeof S.getOccClass>) {
    const {payload} = action;
    const {caseNumber, plan} = payload;
    const {life70Name} = plan;

    const response: AsyncResult<SalaryDeductionOccupationClassInfo> = yield call(
      getSalaryDeductionOccupationClassInfo,
      caseNumber,
      life70Name!
    );

    if (E.isRight(response)) {
      yield put(S.changeOccClass(new Loaded(response.right)));
    } else if (response.left.key === 'Unauthorized') {
      yield put(push(ApplicationEntryRouteConstants.AWDLogin));
    } else {
      if (
        response.left.key === 'NotFound' &&
        response.left.errorDetails!.messages.some(
          (m: {message: string; responseSeverity: string}) =>
            m.message === 'Description: Salary deduction information for the provided input was not found.'
        )
      ) {
        yield put(
          S.changeOccClass(
            new SalaryDeductionOccupationClassInfoWarning(
              'An occupation class that is based on the provided arguments could not be found.'
            )
          )
        );
      } else {
        yield put(S.changeOccClass(response.left));
      }
    }
  });
}

export default function*() {
  yield all([getPackageList(), getSalaryDeductionOccupationClass()]);
}
